import CreateProject from "./CreateProject";
import {
  Box,
  Dialog,
  DialogTitle,
  IconButton,
  Typography
} from "@mui/material";
import useCreateProject from "../hooks/useCreateProject";
import { CloseRounded } from "@mui/icons-material";
import FlowStepper from "../components/FlowStepper";

const CreateProjectDialog = () => {
  const { handleClose } = useCreateProject();

  return (
    <Dialog
      open={true}
      onClose={(_, reason) => {
        if (reason !== "backdropClick") {
          handleClose();
        }
      }}
      fullWidth
      maxWidth={false}
      PaperProps={{
        elevation: 3,
        sx: {
          maxWidth: 1440,
          height: "calc(100% - 64px)",
          maxHeight: 960
        }
      }}
      sx={{
        backgroundColor: "transparent"
      }}
    >
      <DialogTitle
        sx={{
          pl: 3,
          pr: 2,
          paddingY: 1,
          minHeight: 62,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center"
        }}
        component={"div"}
      >
        <Box
          flexGrow={1}
          display="flex"
          gap={2}
          alignItems="center"
          maxWidth={140}
        >
          <Typography variant="h6">Create Project</Typography>
        </Box>
        <Box flexGrow={1}>
          <FlowStepper />
        </Box>
        <Box
          flexGrow={1}
          maxWidth={140}
          display={"flex"}
          justifyContent={"flex-end"}
        >
          <IconButton onClick={handleClose}>
            <CloseRounded />
          </IconButton>
        </Box>
      </DialogTitle>
      <CreateProject />
    </Dialog>
  );
};

export default CreateProjectDialog;
